//@ts-ignore
import { DashboardLayout as DashboardLayoutService } from "@careinfo/layout";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { Outlet } from "react-router-dom";
import BranchIcon from "../Icons/BranchIcon";
import ConsignmentIcon from "../Icons/ConsignmentIcon";
import CustomerIcon from "../Icons/CustomerIcon";
import DispatchManifestIcon from "../Icons/DispatchManifestIcon";
import MerchantIcon from "../Icons/MerchantIcon";
import OverViewIcon from "../Icons/OverViewIcon";
import PickUpRequest from "../Icons/PickUpRequest";
import ReceiveManifestIcon from "../Icons/ReceiveManifestIcon";
import RiderIcons from "../Icons/RiderIcons";
import SettingIcon from "../Icons/SettingIcon";
import StaffIcon from "../Icons/StaffIcon";
import TrashIcon from "../Icons/TrashIcon";
import WelcomeIcon from "../Icons/WelcomeIcon";
import APIS from "../constant/Endpoint";
import useTenantGetHook from "../customHooks/useTenantControlGetHook";
import { hasAccess } from "../utils/permission";
import RunsheetIcon from "../Icons/RunsheetIcon";

const DashboardLayout = () => {
  const shouldShowWelcome = window.localStorage.getItem("shouldShowWelcome");
  const { data, isLoading } = useTenantGetHook({
    queryKey: [`permission`],
    url: `${APIS.PERMISSION}`,
    params: {},
  });

  const permissionsLists: any = data?.custom_permissions;

  const navigation: any = [
    {
      name: "Dashboard",
      href: "/",
      icon: "",
      children: [
        ...(shouldShowWelcome === "true" || shouldShowWelcome === null
          ? [
              {
                name: "Welcome",
                href: "/",
                icon: WelcomeIcon,
                activeIcon: WelcomeIcon,
              },
              {
                name: "Overview",
                href: "/overview",
                icon: OverViewIcon,
                activeIcon: OverViewIcon,
              },
            ]
          : [
              {
                name: "Overview",
                href: "/",
                icon: OverViewIcon,
                activeIcon: OverViewIcon,
              },
            ]),
      ],
    },
    {
      name: "Operations",
      href: "/",
      icon: "",
      children: [
        {
          name: "Consignments",
          href: "/order",
          icon: ConsignmentIcon,
          activeIcon: ConsignmentIcon,
          children: [],
        },
        {
          name: "Daraz",
          href: "/daraz-order",
          icon: ConsignmentIcon,
          activeIcon: ConsignmentIcon,
          children: [],
        },
        {
          name: "Hold Consignments",
          href: "/hold-orders",
          icon: ConsignmentIcon,
          activeIcon: ConsignmentIcon,
          children: [],
        },
        ...(hasAccess(
          ["can_view_international_pickup_request"],
          permissionsLists
        )
          ? [
              {
                name: "Pickup Manifest",
                href: "/international-pickup-request",
                icon: PickUpRequest,
                activeIcon: PickUpRequest,
                children: [],
              },
            ]
          : [
              {
                name: "Pickup Sheet",
                href: "/courier-pickup-request",
                icon: PickUpRequest,
                activeIcon: PickUpRequest,
                children: [],
              },
            ]),
        {
          name: "Vehicle Manifest",
          href: "/vehicle-manifest",
          icon: DispatchManifestIcon,
          activeIcon: DispatchManifestIcon,
          children: [],
        },
        {
          name: "Trash",
          href: "/trash-order",
          icon: TrashIcon,
          activeIcon: TrashIcon,
          children: [],
        },
        {
          name: "Runsheet",
          href: "/runsheet",
          icon: RunsheetIcon,
          activeIcon: RunsheetIcon,
          children: [],
        },

        {
          name: "RTV Branch",
          href: "/return-branch",
          icon: PickUpRequest,
          activeIcon: PickUpRequest,
          children: [],
        },
        {
          name: "Daily Note",
          href: "/daily-notes",
          icon: OverViewIcon,
          activeIcon: OverViewIcon,
          children: [],
        },
      ],
    },
    // {
    //   name: "Manifest",
    //   href: "/",
    //   icon: "",
    //   children: [
    //     {
    //       name: "Dispatch Manifest",
    //       href: "/dispatch-manifest",
    //       icon: DispatchManifestIcon,
    //       activeIcon: DispatchManifestIcon,
    //       children: [],
    //     },
    //     {
    //       name: "Receive Manifest",
    //       href: "/receive-manifest",
    //       icon: ReceiveManifestIcon,
    //       activeIcon: ReceiveManifestIcon,
    //       children: [],
    //     },
    //   ],
    // },
    {
      name: "User Management",
      href: "/",
      icon: "",
      children: [
        {
          name: "Customer",
          href: "/customer",
          icon: CustomerIcon,
          activeIcon: CustomerIcon,
        },
        {
          name: "Staff",
          href: "/staff",
          icon: StaffIcon,
          activeIcon: StaffIcon,
        },
        {
          name: "Rider/Driver",
          href: "/rider",
          icon: RiderIcons,
          activeIcon: RiderIcons,
        },
        {
          name: "Merchant",
          href: "/merchant",
          icon: MerchantIcon,
          activeIcon: MerchantIcon,
        },
      ],
    },
    {
      name: "Finance/Invoice",
      href: "/",
      icon: "",
      children: [
        {
          name: "Overview",
          href: "/finance-overview-invoice",
          icon: OverViewIcon,
          activeIcon: OverViewIcon,
        },
        {
          name: "Merchant",
          href: "/finance-merchant-invoice",
          icon: MerchantIcon,
          activeIcon: MerchantIcon,
        },
        {
          name: "Rider/Driver",
          href: "/finance-rider-invoice",
          icon: RiderIcons,
          activeIcon: RiderIcons,
        },
        {
          name: "Branch",
          href: "/finance-branch-invoice",
          icon: BranchIcon,
          activeIcon: BranchIcon,
        },
      ],
    },
    {
      name: "Administration",
      href: "/",
      icon: "",
      children: [
        {
          name: "Settings",
          href: "/settings",
          icon: SettingIcon,
          activeIcon: SettingIcon,
        },
      ],
    },
  ];
  return (
    <DashboardLayoutService navigation={navigation}>
      <div className={tw`h-full p-2 overflow-y-auto`}>
        <Outlet />
      </div>
    </DashboardLayoutService>
  );
};

export default DashboardLayout;
